import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 27,
	height: 35,
	viewBox: "0 0 27 35",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.9375 12.4V9C21.9375 4.24 18.225 0.5 13.5 0.5C8.775 0.5 5.0625 4.24 5.0625 9V12.4C2.19375 12.4 0 14.61 0 17.5V29.4C0 32.29 2.19375 34.5 5.0625 34.5H21.9375C24.8062 34.5 27 32.29 27 29.4V17.5C27 14.61 24.8062 12.4 21.9375 12.4ZM8.4375 9C8.4375 6.11 10.6313 3.9 13.5 3.9C16.3687 3.9 18.5625 6.11 18.5625 9V12.4H8.4375V9ZM15.1875 26C15.1875 27.02 14.5125 27.7 13.5 27.7C12.4875 27.7 11.8125 27.02 11.8125 26V20.9C11.8125 19.88 12.4875 19.2 13.5 19.2C14.5125 19.2 15.1875 19.88 15.1875 20.9V26Z",
		fill: "#3E445C"
	})
});
export default SvgLock;
